import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { BRAND } from "../App";

const Footer = () => {
  return (
    <footer className="bg-black text-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8 mb-10">
          <div className="md:col-span-2">
            <img src={BRAND.logoAlt} alt={BRAND.name} className="h-16 w-auto mb-4 brightness-110" />
            <p className="text-white/60 text-sm max-w-sm mb-4">
              Reliable vehicle transportation you can count on. Local & long distance transport, towing, rentals, and sales for dealerships, auctions, business & personal.
            </p>
            <div className="flex items-center gap-2 text-white/80">
              <Phone size={16} className="text-[#E31E24]" />
              <span className="text-xs uppercase tracking-wide text-white/50">Call or Text</span>
              <a href={BRAND.phoneHref} className="font-bold hover:text-[#E31E24] transition-colors">{BRAND.phone}</a>
            </div>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-white uppercase tracking-wide text-sm">Services</h4>
            <ul className="space-y-2 text-white/70 text-sm">
              <li><Link to="/services" className="hover:text-[#E31E24] transition-colors">Vehicle Transport</Link></li>
              <li><Link to="/services" className="hover:text-[#E31E24] transition-colors">Local Towing</Link></li>
              <li><Link to="/services" className="hover:text-[#E31E24] transition-colors">Dealership Transport</Link></li>
              <li><Link to="/services" className="hover:text-[#E31E24] transition-colors">Auction Pickup</Link></li>
              <li><Link to="/services" className="hover:text-[#E31E24] transition-colors">Motorcycle Transport</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold mb-4 text-white uppercase tracking-wide text-sm">Quick Links</h4>
            <ul className="space-y-2 text-white/70 text-sm">
              <li><Link to="/get-quote" className="hover:text-[#E31E24] transition-colors">Get a Quote</Link></li>
              <li><Link to="/cars-for-sale" className="hover:text-[#E31E24] transition-colors">Cars for Sale</Link></li>
              <li><Link to="/about" className="hover:text-[#E31E24] transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-[#E31E24] transition-colors">Contact</Link></li>
              <li><a href={BRAND.emailHref} className="hover:text-[#E31E24] transition-colors flex items-center gap-1"><Mail size={12} />Email Us</a></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center gap-4 text-white/40 text-xs">
          <p>&copy; {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <p>Contact {BRAND.owner} at {BRAND.phone}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
